import React from "react";
import FinancialYearEndList from "../Modules/FinancialYearEnd/FinancialYearEndList";
import WebMenu from "../Modules/Configurations/WebMenu/WebMenu";


const Login = React.lazy(() => import("../Modules/Authentication/Login"));
const ChangePassword = React.lazy(() =>
  import("../Modules/Authentication/ChangePassword"),
);
const Dashboard = React.lazy(() => import("../Modules/TD/Dashboard"));
const InsuranceRenewal = React.lazy(
  () => import("../Modules/InsuranceRenewal/InsuranceRenewal"),
);
const TermDeposit = React.lazy(() => import("../Modules/TD/TermDeposit"));
const Building = React.lazy(() => import("../Modules/Building/BuildingList"));
const TermDepositDetails = React.lazy(
  () => import("../Modules/TD/TermDepositDetails"),
);
const RolesManagement = React.lazy(
  () => import("../Modules/Configurations/Roles/RolesManagement"),
);
const UsersManagement = React.lazy(
  () => import("../Modules/Configurations/Users/UsersManagement"),
);
const MeetingRegisterSettings = React.lazy(
  () => import("../Modules/Configurations/Seetings/MeetingRegisterSettings"),
);
const Profile = React.lazy(() => import("../Modules/User/Profile"));
const MeetingRegister = React.lazy(
  () => import("../Modules/MeetingRegister/MeetingRegister"),
);
const TDSendReminder = React.lazy(() => import("../Modules/TD/TDSendReminder"));
const TDSendReminderForms = React.lazy(
  () => import("../Modules/TD/TDSendReminderForms"),
);
const TDSendReminderRollOverForms = React.lazy(
  () => import("../Modules/TD/RollOverTermDeposit"),
);
const InstructionTermDeposit = React.lazy(
  () => import("../Modules/TD/InstructionTermDeposit"),
);
const CloseRedeemTermDeposit = React.lazy(
  () => import("../Modules/TD/CloseRedeemTermDeposit"),
);
const RollbackInstructions = React.lazy(
  () => import("../Modules/TD/RollbackInstructions"),
);
const ViewWebMenuManagement = React.lazy(
  () => import("../Modules/Configurations/WebMenu/ViewWebMenu"),
);
const ThankYouPage = React.lazy(
  () => import("../Components/layout/ThankYouPage"),
);
const AIAssistant = React.lazy(() => import("../Modules/Assistance/AIAssistant"));
const routes = [
  // dashboard routes
  {
    path: "/",
    element: <div />,
    access: "publicFree",
    layout: "none",
  },
  {
    path: "/login",
    element: <Login />,
    access: "public", //public = only guests (redirect if already logged in)
    layout: "none", // no frame for landing page
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
    access: "public",
    layout: "none",
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/roles",
    element: <RolesManagement />,
    access: "private",
    layout: "frame",
  },
  {
    path: "/users-management",
    element: <UsersManagement />,
    access: "private",
    layout: "frame",
  },
  {
    path: "/meeting-register-settings",
    element: <MeetingRegisterSettings />,
    access: "private",
    layout: "frame",
  },
  {
    path: "/building",
    element: <Building />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/financial-year",
    element: <FinancialYearEndList />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/term-deposit",
    element: <TermDeposit />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/insurance-renewal",
    element: <InsuranceRenewal />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/meeting-register",
    element: <MeetingRegister />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/profile",
    element: <Profile />,
    access: "private", // private = only logged in users
    layout: "frame",
  },
  {
    path: "/term-deposit/details/:id",
    element: <TermDepositDetails />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/term-deposit/reminder/:id",
    element: <TDSendReminder />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/term-deposit/reminder/forms",
    element: <TDSendReminderForms />,
    access: "private", // private = only logged in users
    layout: "frame", // use frame layout
  },
  {
    path: "/term-deposit/rollOver-form",
    element: <TDSendReminderRollOverForms />,
    access: "public", // private = only logged in users
    layout: "none", // use frame layout
  },
  {
    path: "/term-deposit/instruction-form",
    element: <InstructionTermDeposit />,
    access: "public", // private = only logged in users
    layout: "none", // use frame layout
  },
  {
    path: "/term-deposit/close-redeem-form",
    element: <CloseRedeemTermDeposit />,
    access: "public", // private = only logged in users
    layout: "none", // use frame layout
  },
  {
    path: "/thank-you-page",
    element: <ThankYouPage />,
    access: "public", // private = only logged in users
    layout: "none", // use frame layout
  },
  {
    path: "/term-deposit/rollback-instructions/:email_token",
    element: <RollbackInstructions />,
    access: "private", // private = only logged in users
    layout: "none", // use frame layout
  },
  {
    path: "/web-menu",
    element: <WebMenu />,
    access: "private",
    layout: "frame",
  },
  {
    path: "/web-menu/view/:id",
    element: <ViewWebMenuManagement />,
    access: "private",
    layout: "frame",
  },
  {
    path: "/assistance",
    element: <AIAssistant />,
    access: "private",
    layout: "frame",
  },
];
export default routes;
